import { FailureSeverity, ValidationFailure } from "./ValidationResult";

export const splitFailuresToErrorsAndWarnings = (
    failures: ValidationFailure[]
): { errorList: ValidationFailure[]; warningList: ValidationFailure[] } => {
    const errorList: ValidationFailure[] = [];
    const warningList: ValidationFailure[] = [];

    failures.forEach((failure: ValidationFailure) => {
        if (failure.severity === FailureSeverity.Error) {
            errorList.push(failure);
        } else {
            warningList.push(failure);
        }
    });

    return {
        errorList,
        warningList
    };
};
